import { render, staticRenderFns } from "./SalesAnalytics.vue?vue&type=template&id=240061ea&"
import script from "./SalesAnalytics.vue?vue&type=script&lang=js&"
export * from "./SalesAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./SalesAnalytics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports